import type { NestedSuggestion, Suggestion } from '../../components/Suggestions/types';

export function reduceSuggestionsIntoNestedSuggestions(
	output: NestedSuggestion[],
	suggestion: Suggestion,
): NestedSuggestion[] {
	const { nestingConfig } = suggestion;

	if (nestingConfig) {
		const existingIndex = output.findIndex(
			(s) => s.nestingConfig?.parentTitle === nestingConfig.parentTitle,
		);

		if (existingIndex === -1) {
			const parentNestingConfig = { ...nestingConfig };
			delete parentNestingConfig.shortTitle;

			output.push({
				childSuggestions: [suggestion],
				description: suggestion.description,
				groupHeading: suggestion.groupHeading,
				hideIcon: suggestion.hideIcon,
				icon: suggestion.icon,
				isAgent: suggestion.isAgent,
				label: nestingConfig.parentTitle || '',
				nestingConfig: parentNestingConfig,
				onParentSelect: suggestion.onParentSelect,
				onSelect: suggestion.onParentSelect ?? suggestion.onSelect,
				onSuggestionFocused: suggestion.onSuggestionFocused,
				rightText: suggestion.rightText,
				statusLozengeType: suggestion.statusLozengeType,
				testId: nestingConfig.parentTestId,
				value: suggestion.nestingConfig?.parentTitle || '',
			});
		} else {
			output[existingIndex].childSuggestions?.push(suggestion);
			if (!output[existingIndex].onParentSelect && suggestion.onParentSelect) {
				output[existingIndex].onParentSelect = suggestion.onParentSelect;
				output[existingIndex].onSelect = suggestion.onParentSelect;
			}
		}
	} else {
		output.push(suggestion);
	}

	return output;
}
